import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { reset } from 'redux-form';
import { getDeviceState } from '../../core/services/stateless.services';
import DeviceStateForm from './components/DeviceStateForm';

interface IDeviceStateState{
  ICCID:string,
  recievedJSONText:any,
} 
const DeviceStateInitialValue:IDeviceStateState = {
  ICCID:"",
  recievedJSONText:"",
}

const DeviceState = (props: any) => {
  const [initialValues, setInitialValues] = useState<IDeviceStateState>(DeviceStateInitialValue);
  const dispatch = useDispatch();
  
  const onSubmitForm = (values: any) => {
    let iccid=values.ICCID;
    getDeviceState(iccid,setInitialValues);
    // onModalClosed();
  }

  const onModalClosed = () => {
    dispatch(reset('DeviceStateForm'));
    props.modalClosed();
  }

  return (
    <React.Fragment>
      <DeviceStateForm
        initialValues={initialValues}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default DeviceState;
